import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import DownArrow from '../../assets/down-arrow-black.svg'
import './timePicker.css'
import moment from 'moment-timezone'
import ClockIcon from 'src/assets/Content-Icons/PNGs/clock-icon-publish.png'

const TimePicker = ({
  time,
  setTime,
  customPadding = '4px 11px',
  customFontSize = '.8vw',
  customWidth = '7.4vw',
  disabled = false,
}) => {
  const timeRef = useRef(null)
  const [hours, setHours] = useState(12)
  const [minutes, setMinutes] = useState(0)
  const [meridiem, setMeridiem] = useState('PM')
  const [clockVisibility, setClockVisibility] = useState(false)
  console.log('time', time)
  useEffect(() => {
    if (time) {
      let tempTime = time.split(':')

      setHours(Number(tempTime[0]))
      setMinutes(Number(tempTime[1]))
      setMeridiem(Number(tempTime[0]) >= 12 ? 'PM' : 'AM')
    }
  }, [time])

  const handleHours = (type) => {
    if (type === 'DECREASE') {
      let peakValue = meridiem === 'AM' ? 11 : 23
      setTime(`${hours === (meridiem === 'AM' ? 0 : 12) ? peakValue : hours - 1}:${minutes}`)
    }
    if (type === 'INCREASE') {
      let peakValue = meridiem === 'AM' ? 0 : 12

      setTime(`${hours === (meridiem === 'AM' ? 11 : 23) ? peakValue : hours + 1}:${minutes}`)
    }
  }
  const handleMinute = (type) => {
    if (type === 'INCREASE') {
      setTime(`${hours}:${minutes === 59 ? 0 : minutes + 1}`)
    }
    if (type === 'DECREASE') {
      setTime(`${hours}:${minutes === 0 ? 59 : minutes - 1}`)
    }
  }

  const handleMeridiem = () => {
    let newHour = meridiem === 'AM' ? hours + 12 : hours - 12
    setTime(`${newHour}:${minutes}`)
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (timeRef.current && !timeRef.current.contains(event.target)) {
        setClockVisibility(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [timeRef])
  return (
    <div ref={timeRef}>
      <p
        className=" mb-0"
        style={{
          background: '#fff',
          width: customWidth,
          height: '33px',
          padding: customPadding,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          border: 'thin solid gray',
          fontSize: customFontSize,
          opacity: disabled ? '0.8' : '1',
        }}
        onClick={disabled ? null : () => setClockVisibility(!clockVisibility)}
      >
        <span>{moment(time, 'HH:mm').format('hh:mm A')}</span>
        <img src={ClockIcon} alt="" style={{ height: '1.3vw' }} />
      </p>
      <div
        style={{
          display: clockVisibility ? 'block' : 'none',
          position: 'absolute',
          top: '80%',
          zIndex: 10,
        }}
      >
        <div className="time-setter-container">
          <div className="time-setter-cols">
            <button
              className="time-setter-arrows arrows-up"
              onClick={() => handleHours('DECREASE')}
            >
              <img src={DownArrow} alt="" />
            </button>
            <span className="text-value">
              {String(hours > 12 ? hours - 12 : hours === 0 ? 12 : hours).padStart(2, '0')}
            </span>
            <button className="time-setter-arrows" onClick={() => handleHours('INCREASE')}>
              <img src={DownArrow} alt="" />
            </button>
          </div>
          <div className="time-setter-cols">
            <button
              className="time-setter-arrows arrows-up"
              onClick={() => handleMinute('DECREASE')}
            >
              <img src={DownArrow} alt="" />
            </button>
            <span className="text-value">{String(minutes).padStart(2, '0')}</span>
            <button className="time-setter-arrows" onClick={() => handleMinute('INCREASE')}>
              <img src={DownArrow} alt="" />
            </button>
          </div>
          <div className="time-setter-cols">
            <button className="time-setter-arrows arrows-up" onClick={handleMeridiem}>
              <img src={DownArrow} alt="" />
            </button>
            <span className="text-value">{meridiem}</span>
            <button className="time-setter-arrows" onClick={handleMeridiem}>
              <img src={DownArrow} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TimePicker
